import { CostCenterDto, UpsertCostCenterDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/cost-center`;

export const getAllCostCenters = (source: CancelTokenSource): Promise<Array<CostCenterDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchCostCentersByDescription = (description: string,
                                               source: CancelTokenSource): Promise<Array<CostCenterDto>> => {
  return axios
      .get(`${apiUri}`,{params: {search: description}, cancelToken: source.token})
      .then(response => response.data);
};

export const addCostCenter = (upsertCostCenterDto: Partial<UpsertCostCenterDto>,
                              source: CancelTokenSource): Promise<CostCenterDto> => {
  return axios
      .post(apiUri, upsertCostCenterDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCostCenter = (id: number,
                               upsertCostCenterDto: Partial<UpsertCostCenterDto>,
                               source: CancelTokenSource): Promise<CostCenterDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertCostCenterDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteCostCenter = (id: number, source: CancelTokenSource): Promise<number> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
